// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import config from '../auth_config.json';

const { domain, clientId, authorizationParams: { audience }, apiUri, errorPath } = config as {
  domain: string;
  clientId: string;
  authorizationParams: {
    audience?: string;
  },
  apiUri: string;
  errorPath: string;
};

export const environment = {
  production: false,
  portalUrl: 'https://seasonalconnecttest.azurewebsites.net',
  auth: {
    domain,
    clientId,
    authorizationParams: {
      ...(audience && audience !== 'YOUR_API_IDENTIFIER' ? { audience } : null),
      redirect_uri: window.location.origin,
    },
    errorPath,
  },
  httpInterceptor: {
    allowedList: [`${apiUri}/api/*`,
    {
      uri: `${apiUri}/signup/SignupEmployer/GetCompanyDetails/*`,
      allowAnonymous: true,
    },
    {
      uri: `${apiUri}/publicapi/PublicPositions/GetPositionById/*`,
      allowAnonymous: true,
    },
    {
      uri: `${apiUri}/publicapi/PublicPositions/GetEmployerForPositionById/*`,
      allowAnonymous: true,
    },
  ],
  },
  appInsights: {
    instrumentationKey: 'cc2f24f8-97c5-44c5-8b2c-ecd6ab437df0'
}
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
